import { Network } from ':fat/core/networks';

import { getAuthHeaders, getBaseUrl } from './client';

export type CheckTransactionsResponse = Record<string, boolean>;

export async function checkTransactions(network: Network, hashes: string[]) {
  const response = await fetch(`${getBaseUrl()}/v2/funds-access/${network}/txs/info`, {
    method: 'POST',
    body: JSON.stringify({ tx_hashes: hashes }),
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(),
    },
  });
  const body = (await response.json()) as { data: CheckTransactionsResponse };
  return body.data;
}
